/* Copyright (c) 2025 Xperi. All Rights Reserved. */

export const TPreviewKernelType = {
    TAllEpisodesKernel: 'tAllEpisodesKernel' as const,
    TAllUpcomingEpisodesKernel: 'tAllUpcomingEpisodesKernel' as const,
    TUpcomingAiringsKernel: 'tUpcomingAiringsKernel' as const,
};

export type TPreviewKernelType = (typeof TPreviewKernelType)[keyof typeof TPreviewKernelType];
